import { css } from 'styled-components';
import { setCssVar } from './cssVar';
import { Device, from } from './media';
/**
 * Include header height variable and base padding value.
 */
export const headerPadding = css `
  ${setCssVar('headerHeight', '75px')};

  padding-top: var(--headerHeight);

  @media ${from(Device.DesktopSmall)} {
    ${setCssVar('headerHeight', '210px')};
  }

  @media ${from(Device.Desktop)} {
    ${setCssVar('headerHeight', '278px')};
  }
`;
